import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CorrespondenceActionPartyDto, CorrespondenceTeamDto, UserStaffDetailDto } from '@cradua/data';
import { GatewayService } from 'libs/gateway/src/lib/services/gateway.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-correspondenceactionparty',
  templateUrl: './correspondenceactionparty.component.html',
  styleUrls: ['./correspondenceactionparty.component.scss']
})
export class CorrespondenceactionpartyComponent implements OnChanges {

  correspondenceActionPartyForm: FormGroup;
  correspondenceActionPartyFormArray: FormGroup;
  control = new FormControl();
  @Input() correspondenceactionpartys: CorrespondenceActionPartyDto[];
  @Input() correspondenceteam: CorrespondenceTeamDto[];
  @Input() correspondencestaff: UserStaffDetailDto[];
  @Input() routeAnimationsElements: any;
  @Output() correspondenceactionparty = new EventEmitter<CorrespondenceActionPartyDto[]>()
  @Output() deleteCorrespondenceActionPartyEvent = new EventEmitter<any>()

    selectedCorrespondenceActionParty: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     private gatewayService: GatewayService,
     ) {}

    ngOnChanges() {
      this.createCorrespondenceActionPartyForm();
    }



    createCorrespondenceActionPartyForm() {
      this.correspondenceActionPartyForm = this.fb.group({
        StaffId: [''],
        CorrespondenceTeamId: [''],
        CorrespondenceActionPartyName: [''],
        Email: [''],
        id: null
        });
        this.correspondenceActionPartyFormArray = this.fb.group({ CorrespondenceActionPartys: this.fb.array([])
          });
        this.setCorrespondenceActionParty();
    }

  // method to display LossOfUseItemss
  setCorrespondenceActionParty() {
    const control  = this.correspondenceActionPartyFormArray.controls.CorrespondenceActionPartys as FormArray;
    this.correspondenceactionpartys.forEach( e => {
      control.push(
        this.fb.group({
          StaffId: e.StaffId,
          CorrespondenceActionPartyName: e.CorrespondenceActionPartyName,
          Email: e.Email,
          CorrespondenceTeamId: e.CorrespondenceTeamId,
          id: e.id
        })
      );
    });
  }

  onSelectStaff(id: string) {
    const foundUser = this.correspondencestaff.find(item => item.id === id);
    if(foundUser) {
      this.correspondenceActionPartyForm.patchValue({
        CorrespondenceActionPartyName: foundUser?.StaffName,
        Email: foundUser['Email'],
      })
    }

  }


  // method to add LossOfUseItems
  addCorrespondenceActionParty(value: CorrespondenceActionPartyDto) {
    const control  = this.correspondenceActionPartyFormArray.controls.CorrespondenceActionPartys as FormArray;
    control.insert(0,
          this.fb.group({
            StaffId: value.StaffId,
            CorrespondenceActionPartyName: value.CorrespondenceActionPartyName,
            Email: value.Email,
            CorrespondenceTeamId: value.CorrespondenceTeamId,
            id: null
          })
       );
  }

  selectCorrespondenceActionParty(value) {

  }

  getTeamName(id: string) {
    const found = this.correspondenceteam.find(team => team.id === id);
   return found ? found.CorrespondenceTeamName : '';
  }
  getStaff(id: string) {
    const found = this.correspondencestaff.find(staff => staff.id === id);
   return found ? found.StaffName : '';
  }
  // method to delete LossOfUseItems from arrary list
  deleteCorrespondenceActionParty(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.correspondenceActionPartyFormArray.controls.CorrespondenceActionPartys as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.correspondenceactionpartys.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.correspondenceactionpartys[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: CorrespondenceActionPartyDto) {
    if(this.correspondenceActionPartyForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.correspondenceActionPartyFormArray.get('CorrespondenceActionPartys')['controls'][this.selectedIndex].patchValue({
        StaffId: formValue.StaffId,
        CorrespondenceTeamId: formValue.CorrespondenceTeamId,
        CorrespondenceActionPartyName: formValue.CorrespondenceActionPartyName,
        Email: formValue.Email,
      });
    } else {
      this.addCorrespondenceActionParty(formValue);
    }
    this.selectedIndex = null;
    this.correspondenceActionPartyForm.reset()
  }

  onEdit(index, value: CorrespondenceActionPartyDto) {
    this.selectedIndex = index;
    this.correspondenceActionPartyForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.correspondenceActionPartyForm.reset();
  }

  onSubmit(formValue: CorrespondenceActionPartyDto[]) {
  this.correspondenceactionparty.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteCorrespondenceActionPartyEvent.emit(this.filteredDelete);
  }
  }


}
